export const SUITABILITY_FETCH_INIT = 'SUITABILITY_FETCH_INIT';
export const SUITABILITY_FETCH_SUCCESS = 'SUITABILITY_FETCH_SUCCESS';
export const SUITABILITY_FETCH_ERROR = 'SUITABILITY_FETCH_ERROR';

export const SUITABILITY_POST_INIT = 'SUITABILITY_POST_INIT';
export const SUITABILITY_POST_SUCCESS = 'SUITABILITY_POST_SUCCESS';
export const SUITABILITY_POST_ERROR = 'SUITABILITY_POST_ERROR';

export const SUITABILITY_RESET = 'SUITABILITY_RESET';
